// @flow
import type { StoreResourceDef } from 'app/core/types'

export const activityApprovals: StoreResourceDef<> = {
  resourceType: 'activityApprovals',
}
